import { Modal } from "@breuni-ui/modal";
import { safeDefine } from "@breuni-ui/safe-define";
import { isBelowBreakpointM } from "../utils/isBelowBreakpointM";

export class KombiModulModal extends Modal {
  private readonly resizeAbortController: AbortController;

  public constructor() {
    super();
    this.resizeAbortController = new AbortController();
  }

  public connectedCallback(): void {
    super.connectedCallback();
    window.addEventListener(
      "resize",
      () => {
        const fullscreen = this.getAttribute("fullscreen");
        const belowBreakpointM = isBelowBreakpointM();
        if (fullscreen === null && belowBreakpointM) {
          this.setAttribute("fullscreen", "true");
        } else if (!belowBreakpointM) {
          this.removeAttribute("fullscreen");
        }
      },
      {
        signal: this.resizeAbortController.signal,
      },
    );
    this.querySelectorAll("img").forEach((img) => {
      img.addEventListener(
        "load",
        () => {
          this.refreshBody();
        },
        { once: true },
      );
    });
  }

  public disconnectedCallback(): void {
    this.resizeAbortController.abort();
  }
}

safeDefine("reco-kombi-modul-modal", KombiModulModal);
